import React, { useContext } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { RouteDictionary } from '../../../../utils';
import { ymAsync } from '../../../../utils/functions/ymWrapper';
import { CustomLink } from '../../../common';
import { BlockNavigation } from '../../../layout/block';
import { DetailedProjectContext } from '../DetailedProjectContext/DetailedProjectContext';

import './DetailedProjectNavigation.scoped.scss';

const DetailedProjectNavigation = () => {
  const { project, collection } = useContext(DetailedProjectContext);
  const { pathname } = useLocation();

  // Данные по взысканию есть лишь у части проектов, поэтому вкладка появляется только
  // когда департамент заполнил реестр и указал ссылку на кабинет.
  const hasCollection = (collection?.length ?? 0) > 0;

  const navItems = [
    {
      label: 'Экономический анализ',
      route: RouteDictionary.PROJECT_ECONOMIC_ANALYSIS,
      event: 'economical-analysis-project-card',
      // index + /economic
      patterns: ['dashboard/project/:uuid', 'dashboard/project/:uuid/economic'],
    },
    {
      label: 'Юридический анализ',
      route: RouteDictionary.PROJECT_LEGAL_ANALYSIS,
      event: 'legal-analysis-project-card',
      patterns: ['dashboard/project/:uuid/legal'],
    },
    {
      label: 'Стратегия взыскания',
      route: RouteDictionary.PROJECT_STRATEGY,
      event: 'collection-strategy-project-card',
      patterns: ['dashboard/project/:uuid/strategy'],
    },
    {
      label: 'Ход взыскания',
      route: RouteDictionary.PROJECT_COLLECTION,
      event: 'collection-progress-project-card',
      patterns: ['dashboard/project/:uuid/collection'],
      requiresCollection: true,
    },
    {
      label: 'Документы',
      route: RouteDictionary.PROJECT_DOCUMENTS,
      event: 'collection-documents-project-card',
      patterns: ['dashboard/project/:uuid/documents'],
    },
    {
      label: 'События',
      route: RouteDictionary.PROJECT_STAGES,
      event: 'collection-events-project-card',
      patterns: ['dashboard/project/:uuid/stages'],
    },
    {
      label: 'Чат',
      route: RouteDictionary.PROJECT_CHAT,
      event: 'collection-events-project-card',
      patterns: ['dashboard/project/:uuid/chat'],
    },
  ];

  return (
    <BlockNavigation className="detailed-project-navigation">
      {navItems
        .filter(({ requiresCollection }) => !requiresCollection || hasCollection)
        .map(({ label, route, event, patterns }) => {
          const isActive = patterns.some((pattern) => matchPath(pattern, pathname));
          const itemClass = isActive
            ? 'detailed-project-navigation__element-active'
            : 'detailed-project-navigation__element';

          return (
            <li key={label} className={itemClass}>
              <CustomLink
                to={route}
                params={{ uuid: project.uuid }}
                className="detailed-project-navigation__link"
                explicitActive={isActive}
                onClick={() => ymAsync(event)}
              >
                {label}
              </CustomLink>
            </li>
          );
        })}
    </BlockNavigation>
  );
};

export default DetailedProjectNavigation;
